import { jsx } from "react/jsx-runtime";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import './DealerInfo.css';/* empty css                */
const DealerInfoHeader = ({ label, className, onClick }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-header", className), children: /* @__PURE__ */ jsx(
    Button,
    {
      type: "text",
      icon: /* @__PURE__ */ jsx(Icon, { name: "back", className: classnames("perxis-auto-dealer-info-header__icon") }),
      iconPosition: "left",
      iconGapSize: "normal",
      onClick,
      children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-dealer-info-header__label"), children: label })
    }
  ) });
};
export {
  DealerInfoHeader,
  DealerInfoHeader as default
};
//# sourceMappingURL=DealerInfoHeader.js.map
